import React from "react";
import Statistics from "./Statistics";
import CardsAdministradores from "./CardsDashboardAdministrador";
import MyProfile from "./MyProfile";
import CustomBanner from "./CustomBanner";
import { useSelector } from "react-redux";
import PreRegistroVisitantesQR from "./PreRegistroVisitantesQR";
import WhatsAppQRDashboard from "./WhatsAppQRDashboard";
import { useWhiteLabel } from "context/WhiteLabelContext";
import ActivosDashboard from "../CitoPlus/administradores/Dashboard/ActivosDashboard";

const Home = () => {
  const permisos = useSelector(
    (state) => state.permissions.permisos_desde_perfil,
  );
  const { shouldHideDashboardComponent } = useWhiteLabel();

  const showPreRegistroQR =
    permisos.pre_registro_visitante &&
    !shouldHideDashboardComponent("PreRegistroVisitantesQR");

  const showWhatsAppQR =
    permisos.whatsapp_messaging &&
    !shouldHideDashboardComponent("WhatsAppQRDashboard");

  return (
    <>
      <div className="row">
        <div className="col-xl-12">
          <div className="">
            <div className="col-xl-12 pt-3">
              <CustomBanner />
            </div>
            <div className="col-xl-12">
              <MyProfile />
            </div>
            <div className="col-xl-12 pt-4">
              <div className="row">
                <Statistics />
              </div>
            </div>
            <div className="col-xl-12 pt-4">
              <div className="row">
                <ActivosDashboard />
              </div>
            </div>
            <div className="row pt-3">
              {showPreRegistroQR && (
                <div
                  className="col-xl-3"
                  data-whitelabel="PreRegistroVisitantesQR"
                >
                  <PreRegistroVisitantesQR />
                </div>
              )}
              {showWhatsAppQR && (
                <div className="col-xl-3" data-whitelabel="WhatsAppQRDashboard">
                  <WhatsAppQRDashboard />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Home;
